module.exports = __webpack_public_path__ + "static/media/about_fieldhospital.07a65ab9.JPG";